import React, { useEffect, useState } from 'react';
import {
    BuildingOfficeIcon,
    GlobeAltIcon,
    UserGroupIcon,
    ChartBarIcon,
    LightBulbIcon,
    WrenchScrewdriverIcon,
    MegaphoneIcon,
    BookOpenIcon,
    TrophyIcon,
    AcademicCapIcon,
    DocumentMagnifyingGlassIcon,
    ArrowTrendingUpIcon,
    ShieldCheckIcon,
    CpuChipIcon,
    BanknotesIcon
} from '@heroicons/react/24/outline';
import Navbar from '../component/Navbar';
import HeroHeader from '../component/HeroHeader';
import InteractiveGlobe from '../component/InteractiveGlobe';
import SimpleInteractiveEarth from '../component/SimpleInteractiveEarth';
import Footer from '../component/Footer';
import WASMEObjectives from '../component/WASMEObjectives';
import VisionMission from '../component/VisionMission';

const AboutUs = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const stats = [
        { label: 'Years of Service', value: '45+' },
        { label: 'UN Agency Affiliations', value: '9+' },
        { label: 'Countries Reached', value: '150+' },
        { label: 'MSMEs Supported', value: '50K+' },
    ];



    return (
        <><Navbar />
            <div className="min-h-screen bg-gradient-to-b from-white to-blue-50">
                {/* Hero Section */}
                <HeroHeader
                    title="About"
                    highlight="WASME"
                    subtitle="World Association for Small and Medium Enterprises"
                    backgroundImage="/img/wasme_office.png"
                    height="40vh"
                />

                {/* Stats Section */}


                {/* Introduction Section */}
                <div className="relative py-16 sm:py-14">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-3xl lg:max-w-none">
                            <div className={`grid grid-cols-1 gap-12 lg:grid-cols-2 transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                                <div>
                                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                                        Global Leadership in MSME Development
                                    </h2>
                                    <div className="mt-6 space-y-6 text-gray-600 text-justify">
                                        <p className="text-lg">
                                            <span className="font-semibold text-[rgb(43,147,208)]">WASME</span> is the only international NGO that enjoys consultative/observer status with many UN agencies such as ECOSOC, UNCTAD, ITC, WIPO, UNIDO, UNESCO, UNCITRAL, UNESCAP and ILO, several intergovernmental and international organizations like WCO, OECD, ICSB, APEC, APCTT, etc. to promote and support MSMEs around the world for more than 45 years.
                                        </p>
                                        <p>
                                            WASME is an International Non-Governmental Organization that has been promoting the growth & development of MSMEs globally through end to end assistance/solutions including Technology Transfer and Upgradation, Advanced Skill Development Training programme including EDP, Testing and Quality Control, National/International Standardization, Prototype and product design development, Packaging solutions for products/components, Marketing and Export Promotion etc. in all industry sectors for growth and competitiveness and also offers access to financing, knowledge management through Policy Advocacy, Information Dissemination, Conferences, Seminars, Events, publications, Network linkages etc.
                                        </p>
                                    </div>
                                </div>
                                <div className="relative">

                                    <div className="mt-8">
                                        <SimpleInteractiveEarth />
                                    </div>
                                    <div className="mt-8 bg-white rounded-xl shadow-lg p-6 border-l-4 text-justify border-blue-300">
                                        <h3 className="text-xl font-bold text-gray-900 mb-4">Our Global Community</h3>
                                        <p className="text-gray-600">
                                            We have created world largest and cohesive community that promotes MSMEs in the world including UN agencies, national and international organizations, financial institutions, research institutes, banks, civil societies to achieve sustainable Development of MSMEs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Vision & Mission Section */}
                <div className=" py-8">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="text-center mb-12">
                            <h2 className="text-3xl font-bold text-gray-900">Our Vision & Mission</h2>
                            <div className="mt-4 h-1 w-24 bg-blue-300 mx-auto"></div>
                        </div>
                        <VisionMission/>

                        {/* Objectives Grid */}
                        <WASMEObjectives />
                    </div>
                </div>

                {/* Activities Section */}
                <Footer />
            </div>
        </>
    );
};

export default AboutUs;